// Цветът на етикета на дневно меню — едно правило за „Маркиране" (каталогът) и
// справката „По артикули" / „По рецепти": менютата по реда на създаване
// (най-малкото id с това име), всяко име — свой цвят; след четвъртото цветовете
// се повтарят. Червено НЯМА: в „Маркиране" то е „Изчерпано". Самите цветове са
// на всеки модул (pos-* класове / тоновете на таблицата), редът им е един:
// оранжево, синьо, зелено, сиво.

export const LUNCH_MENU_COLOR_COUNT = 4;

/** Имената на менютата, всяко веднъж, по реда на създаване — огледало на BE
 *  `service_lunch_menu_rows.menu_names_in_order`. */
export const lunchMenuNamesInOrder = (menus: { id: number; name: string }[]): string[] => {
  const firstIdByName = new Map<string, number>();
  for (const menu of menus) {
    const firstId = firstIdByName.get(menu.name);
    if (firstId === undefined || menu.id < firstId) firstIdByName.set(menu.name, menu.id);
  }
  return [...firstIdByName.keys()].sort((a, b) => firstIdByName.get(a)! - firstIdByName.get(b)!);
};

/** Мястото на цвета (0 … LUNCH_MENU_COLOR_COUNT − 1); непознато меню — първият. */
export const lunchMenuColorIndex = (name: string | null | undefined, namesInOrder: string[]): number => {
  const index = name ? namesInOrder.indexOf(name) : -1;
  return index < 0 ? 0 : index % LUNCH_MENU_COLOR_COUNT;
};

/** Цветът на групата на менюто в „Маркиране" (бутонът горе, фонът на кутийките
 *  при оцветяване „По група") — CSS променлива, не hex: цветът на група се ползва
 *  само като CSS стойност (`color-mix`/`background`). Първият е `pos-lunch`
 *  (= бутона „Поръчай"), какъвто беше общият досега. */
export const LUNCH_MENU_GROUP_COLORS = [
  "var(--color-pos-lunch)",
  "var(--color-info)",
  "var(--color-ok)",
  "var(--color-pos-dim)",
];

export interface LunchMenuLabel {
  name: string;
  colorIndex: number;
}

/** {id на менюто: име и цвят} — за мониторите, които виждат само `lunchMenuId`. */
export const lunchMenuLabelsById = (menus: { id: number; name: string }[]): Map<number, LunchMenuLabel> => {
  const namesInOrder = lunchMenuNamesInOrder(menus);
  return new Map(
    menus.map((menu) => [menu.id, { name: menu.name, colorIndex: lunchMenuColorIndex(menu.name, namesInOrder) }]),
  );
};
